import PropTypes from 'prop-types';

NumberSliderInput.propTypes = {
  labelText: PropTypes.string.isRequired,
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  value: PropTypes.any,
  fieldName: PropTypes.string.isRequired,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  suffix: PropTypes.string,
  prefix: PropTypes.string,
  showValueSuffix: PropTypes.bool,
  className: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default function NumberSliderInput({
  labelText,
  minValue,
  maxValue,
  value,
  fieldName,
  step = 1,
  onChange,
  suffix = '',
  prefix = '',
  showValueSuffix = true,
  description,
  className = '',
  inputClassName = '',
  disabled = false,
}) {
  function handleRangeChange(e) {
    const fakeEvent = {
      target: {
        name: e.target.name,
        value: e.target.valueAsNumber,
        valueAsNumber: e.target.valueAsNumber,
      },
    };
    onChange(fakeEvent);
  }
  return (
    <div className={`flex flex-col mt-2 mr-1 ${className}`}>
      <div className="label">
        <span className="label-text">{labelText}</span>
      </div>
      <div className="flex items-center">
        <input
          disabled={disabled}
          onChange={handleRangeChange}
          type="range"
          min={minValue}
          max={maxValue}
          step={step}
          name={fieldName}
          value={value}
          className={`range ${disabled ? 'disabled opacity-50' : 'range-secondary'} ${inputClassName}`}
        />
        <span
          className={`min-w-5 ml-5 text-sm ${showValueSuffix ? 'block' : 'hidden'} ${disabled && 'opacity-50'}`}
        >
          {prefix}
          {value}
          {suffix}
        </span>
      </div>
      {description && (
        <div className="label">
          <span className="label-text-alt">{description}</span>
        </div>
      )}
    </div>
  );
}
